import {
  SPORTS_DETAIL_LOAD,
  SPORTS_DETAIL_LOAD_SUCCESS,
  PACKAGE_CHANNEL_LOAD,
  PACKAGE_CHANNEL_LOAD_SUCCESS
} from './actions';
import {
  FAVOURITE_CHANNEL_LOAD,
  FAVOURITE_CHANNEL_LOAD_SUCCESS
} from '../../redux-root/actions';

const initialState = {
  sportsDetailJson: null,
  drawerFavLoaded: false,
  sportsChannelPackageData: null
};

export function sportsDetailReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case SPORTS_DETAIL_LOAD:
      return {
        ...state,
        sportsDetailJson: null
      };

    case SPORTS_DETAIL_LOAD_SUCCESS:
      return {
        ...state,
        sportsDetailJson: data
      };

    case FAVOURITE_CHANNEL_LOAD:
      return {
        ...state,
        drawerFavLoaded: false
      };

    case FAVOURITE_CHANNEL_LOAD_SUCCESS:
      return {
        ...state,
        drawerFavLoaded: true
      };

    case PACKAGE_CHANNEL_LOAD:
      return {
        ...state,
        sportsChannelPackageData: null
      };

    case PACKAGE_CHANNEL_LOAD_SUCCESS:
      return {
        ...state,
        sportsChannelPackageData: data
      };

    default:
      return state;
  }
}
